import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { BodyText, HeadingText, Button, Link } from '@paypalcorp/pp-react';
import OptimizedImage from './OptimizedImage';
import { parseData } from '../../../lib/helpers';
import { useFptiImpression } from '../../../lib/hooks';

const BannerTile = props => {
  const { content, fptiClick, fptiImpression, largeTile } = props;
  const {
    categoryHeader: header,
    categorySubheader: subheader,
    categoryTitle: title,
    categoryBannerImageUrl: imageUrl,
    categoryImageUrlVariant: imageUrlVariant,
    categoryBody: body,
    categoryFPTI,
    cta
  } = content || {};

  const parsedCta = parseData(cta);
  const ctaText = parsedCta[0]?.text;
  const ctaUrl = parsedCta[0]?.url;
  const ref = useRef();
  useFptiImpression(ref, () => {
    fptiImpression({
      pageLink: `${categoryFPTI}_banner`,
      category: 'parent'
    });
  });

  const handleClick = fptiLink => {
    fptiClick({
      fptiLink: (typeof fptiLink === 'string' && fptiLink) || categoryFPTI,
      category: 'parent',
      pageLink: `${categoryFPTI}_banner`
    });
  };

  if (largeTile) {
    return (
      <Link
        className="undo-link-styles add-focus-visible"
        onClick={handleClick}
        href={ctaUrl}
        ref={ref}
      >
        <div className="large-tool-tile">
          <div className="large-tool-inner">
            <div
              className="large-tool-media"
              style={{ backgroundColor: '#1072EB' }}
            >
              <div className="large-tool-wrapper">
                <div
                  className={`lazyload large-tool-image lg-image`}
                  style={{
                    background: `center center no-repeat`,
                    backgroundSize: '100%'
                  }}
                  data-bg={imageUrlVariant}
                />
                <div className="large-tool-body">
                  <h4 className="large-tool-body-text">{header}</h4>
                </div>
              </div>
            </div>
            <div className="large-tool-item-text">
              <div className="large-tool-item-header">
                <HeadingText level={2}  className="large-tool-item-heading">{subheader}</HeadingText>
              </div>
              <h4 className="large-tool-item-subheading">{body}</h4>
            </div>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <section id="appcenter-banner-tile" ref={ref}>
      <div className="banner-wrapper">
        <div className="description-container">
          <div className="body-wrapper">
            <div className="body-text">
              <HeadingText level={2} >{header}</HeadingText>
              <BodyText >{body}</BodyText>
            </div>
            <div className="body-button">
              <Button
                className="get-started-button"
                size="sm"
                secondary
                as={Link}
                onClick={handleClick}
                href={ctaUrl}
              >
                {ctaText}
              </Button>
            </div>
          </div>
        </div>
        <div className="image-container">
          <OptimizedImage
            imageUrl={imageUrl}
            className={`banner-image`}
            title={title}
          />
        </div>
      </div>
    </section>
  );
};

BannerTile.propTypes = {
  content: PropTypes.object,
  fptiClick: PropTypes.func,
  fptiImpression: PropTypes.func,
  largeTile: PropTypes.bool
};

export default BannerTile;
